const NotFoundPage = () => {
    return (
        <>

            <style jsx>{`
                    * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        :root {
            --primary-blue: #87CEEB;
            --secondary-blue: #B0E0E6;
            --accent-blue: #4682B4;
            --text-primary: #2C3E50;
            --text-secondary: #34495E;
            --bg-primary: #F0F8FF;
            --bg-secondary: #E6F3FF;
            --shadow: rgba(70, 130, 180, 0.2);
        }

        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            background: linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-secondary) 100%);
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: var(--text-primary);
            transition: all 0.3s ease;
            overflow-x: hidden;
        }
            `
            }</style>


            <div className="clouds">
                <div className="cloud cloud1"></div>
                <div className="cloud cloud2"></div>
                <div className="cloud cloud3"></div>
            </div>

            <div className="container">
                <div className="error-number">404</div>
                <h1 className="error-title">Oops! Page Not Found</h1>
                <p className="error-message">
                    The page you're looking for seems to have wandered off into the clouds.
                    Don't worry, we'll help you find your way back to solid ground.
                </p>

                <div className="buttons">
                    <a href="/dashboard" className="btn btn-primary">Go to Dashboard</a>
                </div>
            </div>

            <div className="footer">
                Lost in the clouds? We'll guide you back.
            </div>
        </>
    )
}

export default NotFoundPage